import { createTabHandlerExtension } from './createTabHandlerExtension.mjs'

export const TabHandlerExtension = createTabHandlerExtension()
